(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ccl-product-documents"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ccl-product-documents')) {
    customElements.define('ccl-product-documents', class extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form');
        this.update = (event) => {
          const id = String(event.detail?.variant?.id || '');
          this.querySelectorAll('[data-ccl-variant]').forEach((link) => {
            link.hidden = link.dataset.cclVariant !== id;
          });
        };
        this.form?.addEventListener('variant:change', this.update);
      }
      disconnectedCallback() { this.form?.removeEventListener('variant:change', this.update); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
